export default "__VITE_ASSET__DDYo3iyp__"